import { rem } from 'polished';
import styled from 'styled-components';

const SaturationContainer = styled.div`
    box-shadow: ${({ theme }) => theme.base.boxShadow.elevationSmall};
    cursor: crosshair;
    height: ${rem(200)};
    margin-top: ${rem(8)};
    position: relative;
`;

export default SaturationContainer;
